import { render, staticRenderFns } from "./UpdateAccountAgent.vue?vue&type=template&id=282fc38e&scoped=true"
import script from "./UpdateAccountAgent.vue?vue&type=script&lang=js"
export * from "./UpdateAccountAgent.vue?vue&type=script&lang=js"
import style0 from "./UpdateAccountAgent.vue?vue&type=style&index=0&id=282fc38e&lang=css"
import style1 from "./UpdateAccountAgent.vue?vue&type=style&index=1&id=282fc38e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282fc38e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('282fc38e')) {
      api.createRecord('282fc38e', component.options)
    } else {
      api.reload('282fc38e', component.options)
    }
    module.hot.accept("./UpdateAccountAgent.vue?vue&type=template&id=282fc38e&scoped=true", function () {
      api.rerender('282fc38e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/agent/UpdateAccountAgent.vue"
export default component.exports